import { Center, Modal, VStack } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import { useI18n } from '@springbig/shared';
import Button from '~/shared/Button';
import React from 'react';
import { useGeneralStyles } from '~/shared/styles';

type DeleteCardsModalProps = {
    onCancel: () => void;
    onSubmit: () => void;
    isLoading?: boolean;
}

const DeleteCardsModal = ({ onCancel, onSubmit, isLoading }: DeleteCardsModalProps) => {

    const { t } = useI18n();
    const gStyle = useGeneralStyles();

    return (
        <Center>
            <Modal isOpen overflowY={'auto'}>
                <Modal.Content>
                    <Modal.Header>
                        <H3>{ t('giftCard.deleteCardsModal.title') }</H3>
                    </Modal.Header>
                    <Modal.Body>
                        <VStack space={4} textAlign={'center'}>
                            <Caption>
                                { t('giftCard.deleteCardsModal.description') }
                            </Caption>
                            <Caption>
                                { t('giftCard.deleteCardsModal.disclaimer') }
                            </Caption>
                        </VStack>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bg={gStyle.button_neutral_background}
                            _text={{
                                color: gStyle.button_neutral_text,
                            }}
                            mx={'auto'}
                            h={8}
                            py={2}
                            px={5}
                            onPress={() => onCancel()}
                            isDisabled={isLoading}
                        >
                            { t('giftCard.deleteCardsModal.backButton') }
                        </Button>
                        <Button
                            bg={gStyle.button_danger_background}
                            _text={{
                                color: gStyle.button_danger_text,
                            }}
                            mx={'auto'}
                            h={8}
                            py={2}
                            px={5}
                            onPress={() => onSubmit()}
                            isDisabled={isLoading}
                        >
                            { t('giftCard.deleteCardsModal.confirmButton') }
                        </Button>
                    </Modal.Footer>
                </Modal.Content>
            </Modal>
        </Center>
    );
};

export default DeleteCardsModal;
